
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router/index';
import ScrollToTop from './components/feature/ScrollToTop';
import { isMaintenanceModeEnabled } from './utils/maintenanceMode';
import MaintenancePage from './pages/maintenance/page';

function App() {
  // Check if maintenance mode is enabled
  const maintenanceMode = isMaintenanceModeEnabled();

  // If maintenance mode is enabled, show maintenance page
  if (maintenanceMode) {
    return <MaintenancePage />;
  }

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
